import { AntDesign } from '@expo/vector-icons';
import { router } from 'expo-router';
import { StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';

interface Props {
  onPress?: () => void;
  style?: ViewStyle;
  iconColor?: string;
  iconName?: 'arrow-left' | 'arrow-right' | 'close';
  size?: number;
  navigateTo?: any;
  navigationParams?: any;
  hitSlop?: number;
}

const GoBackButton = ({
  onPress,
  style,
  iconColor,
  iconName,
  size,
  navigateTo,
  navigationParams,
  hitSlop = 30
}: Props) => {
  const onGoBack = () => {
    if (navigateTo && router.canDismiss()) {
      router.dismissTo({ pathname: navigateTo, params: navigationParams });
    } else {
      if (router.canDismiss()) {
        router.back();
      } else {
        router.replace('/(app)/(bottomTabs)/home/(topTabs)/npoTabs')
      }
    }
  };
  return (
    <TouchableOpacity
      onPress={() => (onPress ? onPress() : onGoBack())}
      style={style ? style : screenStyles.headerLeft}
      hitSlop={{ top: hitSlop, bottom: hitSlop, left: hitSlop, right: hitSlop }}>
      <AntDesign name={iconName ? iconName : 'left'} size={size ?? 20} color={iconColor ? iconColor : 'black'} />
    </TouchableOpacity>
  );
};
const screenStyles = StyleSheet.create({
  headerLeft: {}
});

export default GoBackButton;
